import { MODE_ROAD, MODE_TRANSFER, UNIT_CO2_UNKNOWN } from '@/lib/constants';
import { Co2Emission } from '@/lib/models/emissions/types';
import { mergeWtw } from '@/lib/models/emissions/utils/merge-wtw';
import { OptionModelSequence } from '@/lib/models/segment/types';
import { EmissionStats } from '@/types';

export const getOptionEmissions = (segments: OptionModelSequence): EmissionStats | undefined => {
  const firstSegment = segments?.[0];
  const unit = firstSegment?.emissions?.unit || UNIT_CO2_UNKNOWN;
  const mode = firstSegment?.emissions?.mode || MODE_ROAD;

  const summedEmissions = segments
    .filter((s) => s.routeType !== MODE_TRANSFER)
    .reduce(
      (accum, segment) => {
        if ('emissions' in segment) {
          const { emissions } = segment;

          return {
            sum: (emissions?.average || 0) + accum.sum,
            wtw: mergeWtw(emissions?.wtw, accum.wtw, 'sum'),
          };
        }
        return accum;
      },
      {
        sum: 0,
        wtw: undefined,
      } as {
        sum: number;
        wtw: Co2Emission | undefined;
      },
    );

  return {
    min: summedEmissions.sum,
    max: summedEmissions.sum,
    average: summedEmissions.sum,
    wtw: summedEmissions.wtw,
    unit,
    mode,
  };
};
